import {Component, Input} from '@angular/core';
import {OverlayService} from '../../../shared/services/overlay.service';
import {UserGroupsPropertiesComponent} from '../user-groups-properties/user-groups-properties.component';
import {UserGroupsService} from '../user-groups.service';
import {PROPERTIES_DATA} from '../../core/user-group-injector-data';
import {Subscription} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {getCurrentUserGroup} from '../store/selectors/current-user-groups.selector';
import {BzgHorizontalFlipAnimation, BzgSlideDown} from 'bz-genome-angular';
import {UpdateLocalUserGroup} from '../store/actions/current-user-group.actions';
import {EUserGroupMenuOptions} from '../../core/user-groups.enum';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'user-groups-conditions',
  templateUrl: 'user-groups-conditions.component.html',
  styleUrls: ['user-groups-conditions.component.scss'],
  animations: [BzgHorizontalFlipAnimation, BzgSlideDown]
})

export class UserGroupsConditionsComponent {
  @Input() menuOptions: {[key:string]: any};
  public currentUserGroup: IUserGroup;
  private _subscriptionCurrentUserGroup: Subscription;
  public properties: {[key: string]: Array<IUserGroupProperty>};
  public expanded = {};
  public userGroupMenuOptions = EUserGroupMenuOptions;

  constructor(private _userGroupService: UserGroupsService,
              private _overlayService: OverlayService, private _store: Store<IAppState>) {
    this._subscriptionCurrentUserGroup = this._store.pipe(select(getCurrentUserGroup)).subscribe((userGroup: IUserGroup) => {
      this.currentUserGroup = userGroup;
      if (this.currentUserGroup.conditions) {
        this.expanded[this.currentUserGroup.conditions.length - 1] = true;
      }
    });
  }

  async ngOnInit() {
    this.properties = await this._userGroupService.getProperties();
  }

  public async openProperties(condition: IUserGroupCondition, index: number) {
    const injectionTokens = new WeakMap();
    injectionTokens.set(PROPERTIES_DATA, {properties: this.properties, condition, onApply: (updatedCondition: IUserGroupCondition) => {
        this.currentUserGroup.conditions.splice(index, 1, _.cloneDeep(updatedCondition));
        this._updateCurrentUserGroup();
      }});
    this._overlayService.showAside($('.bz-sidebar-content')[0], UserGroupsPropertiesComponent, injectionTokens, async () => {
    });
  }

  public removeProperty(condition: IUserGroupCondition, propertyName: string) {
    condition[propertyName] = null;
    this._updateCurrentUserGroup();
  }

  public removeCondition(condition: IUserGroupCondition) {
    _.remove(this.currentUserGroup.conditions, condition);
    this._updateCurrentUserGroup();
  }

  public addNewCondition() {
    const newCondition = {
      area: null,
      location: null,
      organization: null,
      position: null,
      role: null,
      skill: null,
      exclude: false
    };
    this.currentUserGroup.conditions = this.currentUserGroup.conditions ? this.currentUserGroup.conditions : [];
    this.currentUserGroup.conditions.push(newCondition);
    const index = this.currentUserGroup.conditions.length - 1;
    this.expanded[index] = true;
    this.expanded[index - 1] = false;
    this._updateCurrentUserGroup();
  }

  public updateIncludeExclue(condition: IUserGroupCondition, index: number, status: string) {
    condition.exclude = status === 'exclude' ? true : false;
    this._updateCurrentUserGroup();
  }

  private _updateCurrentUserGroup() {
    this._store.dispatch(new UpdateLocalUserGroup(this.currentUserGroup));
  }
}
